import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { fetchAdmin, toErrorMessage } from '../../admin/api';
import { AdminDataTable } from '../../sections/admin/shared';
import { AdminRouteLayout, RequestState, useAsyncState } from './AdminRoutePageShared';

export default function ServiceReportsOverviewPage() {
  const overview = useAsyncState(null);

  useEffect(() => {
    const load = async () => {
      overview.setLoading();
      try {
        const response = await fetchAdmin('/services/overview');
        overview.setData(response);
      } catch (error) {
        overview.setError(toErrorMessage(error));
      }
    };

    load();
  }, []);

  return (
    <AdminRouteLayout title="Overview" breadcrumbTitle="Service Reports">
      <RequestState loading={overview.state.loading} error={overview.state.error}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={7}>
            <AdminDataTable
              title="Provider Metrics"
              description="Service provider report snapshots."
              columns={[
                { field: 'provider', headerName: 'Provider' },
                { field: 'successRate', headerName: 'Success Rate' },
                { field: 'requests', headerName: 'Request Count' },
                { field: 'latency', headerName: 'P95 Latency' },
              ]}
              rows={(overview.state.data?.providers || []).map((row) => ({
                id: row.id,
                provider: row.provider,
                successRate: `${row.success_rate}%`,
                requests: row.request_count,
                latency: `${row.p95_latency_ms} ms`,
              }))}
              emptyTitle="No provider metrics"
              emptyDescription="The provider overview endpoint returned no report rows."
            />
          </Grid>
          <Grid item xs={12} lg={5}>
            <AdminDataTable
              title="Current Incidents"
              description="Open or recent incidents from provider monitoring."
              columns={[
                { field: 'provider', headerName: 'Provider' },
                { field: 'status', headerName: 'Status' },
                { field: 'severity', headerName: 'Severity' },
              ]}
              rows={(overview.state.data?.incidents || []).map((row) => ({
                id: row.id,
                provider: row.provider,
                status: row.status,
                severity: row.severity,
              }))}
              emptyTitle="No incidents"
              emptyDescription="The overview endpoint returned no incidents."
            />
          </Grid>
        </Grid>
      </RequestState>
    </AdminRouteLayout>
  );
}
